import { Switch } from "@mui/material";

import CoAppDataGridDateTimeCell from "../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridListCell from "../../global/components/datagrid/CoAppDataGridListCell";
import CoAppDataGridNameCell from "../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../global/components/datagrid/CoAppDataGridSkeletonCell";
import ThreeDotMenu from "../../global/components/ThreeDotMenu";
import RuleDataGridLongTextCell from "../RuleDataGridLongTextCell";

export const arrayColumns = ["groups", "tags"];
export const ruleLibraryColumns = ["actions", "name", "active", "ruleLocation", "description", "platform", "groups", "tags", "createdAt", "updatedAt"];

export const getRuleLibraryColumns = (
	handleStatusToggleChange,
	handleEditRuleClick,
	handleCopyRuleClick,
	handleDeleteRuleToggle,
	loading
) => [
	{
		field: "name",
		headerName: "Rule name",
		flex: 1,
		valueGetter: (params) => (params === "" || params === null) ? " " : params,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<RuleDataGridLongTextCell value={params.value} hasBeforeEffect={!params.row.active && params.row.isDraft} />
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "active",
		headerName: "Status",
		width: 100,
		align: "center",
		headerAlign: "center",
		sortable: true,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<Switch
						checked={Boolean(params.value)}
						disabled={params.row.isDraft}
						onChange={() => handleStatusToggleChange(params.row)}
					/>
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "platform",
		headerName: "Platform",
		flex: 1,
		sortable: true,
		valueGetter: (params) => params?.name,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<RuleDataGridLongTextCell value={params.row.platform?.name || " "} />
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "ruleLocation",
		headerName: "Location",
		flex: 1,
		sortable: true,
		valueGetter: (params) => params?.name,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.value} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "description",
		headerName: "Description",
		flex: 1,
		sortable: true,
		valueGetter: (params) => (params === "" || params === null) ? " " : params,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<RuleDataGridLongTextCell value={params.value} />
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "groups",
		headerName: "Groups",
		flex: 1,
		sortable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridListCell items={params.value} resource="Groups" />
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "tags",
		headerName: "Tags",
		flex: 1,
		sortable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridListCell items={params.value} resource="Tags" />
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "createdAt",
		headerName: "Created",
		width: 175,
		type: "dateTime",
		valueGetter: (params) => !params ? null : new Date(params),
		sortable: true,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridDateTimeCell value={params.value} />
				}
				isLoading={loading}
			/>
		),
	},
	{
		field: "updatedAt",
		headerName: "Updated",
		width: 175,
		type: "dateTime",
		valueGetter: (params) => !params ? null : new Date(params),
		sortable: true,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridDateTimeCell value={params.value} />
				}
				isLoading={loading}
			/>
		),
	},
	{
		field: "actions",
		type: "actions",
		flex: .1,
		sortable: false,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<div>
						<ThreeDotMenu
							options={[
								{
									name: "Edit",
									optionClickHandler: () => {
										handleEditRuleClick(params.row.id);
									},
								},
								{
									name: "Duplicate",
									optionClickHandler: () => {
										handleCopyRuleClick(params.row.id);
									},
								},
								{
									name: "Delete",
									optionClickHandler: () => {
										handleDeleteRuleToggle(params.row);
									},
								}
							]}
						/>
					</div>
				}
				isLoading={loading}
			/>
		)
	}
];